import { useRef, useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import { Modal, ModalBody, ModalFooter, Button, Table } from "@gpstrackit/react-controls";
import { Alert, AlertTitle } from '@mui/material';

import {
    Icon,
    OutlinedInput,
    InputAdornment,
    FormControl,
} from '@mui/material';

//Actions
import { showRestrictionsHide } from 'Redux/actions';

//Styles
import "./restrictionsModal.scss";

const ShowRawData = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const tableRef = useRef();

    //redux states
    const { openModal, restrictions, settings, model2 } = useSelector(state => state.restrictionsModalRedux);

    const validateProperties = (data) => {
        let validate = data.find(item => 
                item.dmsLevel === settings?.dms?.level &&
                    item.adasLevel === settings?.advanced?.adas?.level &&
                    item.recordProfile === settings?.recordConfig?.config &&
                    item.auxModel === (model2 ? settings?.advanced?.aux?.model2 : settings?.advanced?.aux?.model) &&
                item.privacyControl === settings?.advanced?.privacyControl?.level 
        )
        return !(validate)
    };

    const [openSearch, setOpenSearch] = useState("")
    const [restrictionsList, setRestrictionsList] = useState([])

    const closeModal = () => {
        dispatch(showRestrictionsHide());
        setOpenSearch("");
        setRestrictionsList([]);
    }

    const searchField = (query) => {
        const results = new Set();
        for (let i = 0; i < restrictions.length; i++) {
            const object = restrictions[i];
            for (let key in object) {
                if (object.hasOwnProperty(key) && object[key].includes(query)) {
                    results.add(object);
                    break;
                }
            }
        }
        return Array.from(results);
    }

    useEffect(() => {
        if (openSearch || openSearch === "") {
            const timer = setTimeout(() => {
                let result = searchField(openSearch)
                setRestrictionsList(result)
            }, 500)
            return () => clearTimeout(timer);
        }
    }, [openSearch]);

    useEffect(() => {
        if (openModal) setRestrictionsList(restrictions)
    }, [openModal]);

    return (
        <Modal
            open={openModal}
            title={messages['show_restrictions_modal_title']}
            size="small"
            position="right"
            handleClose={() => closeModal()}
        >
            <ModalBody>
                <div className="restrictions-container">
                    {
                        <Alert severity={validateProperties(restrictions) ? "warning" : "success"}>
                            <AlertTitle style={{ fontSize: 13 }}>{validateProperties(restrictions) ? messages['show_restrictions_current_config_not_allowed'] : messages['show_restrictions_current_config_is_allowed']}</AlertTitle>
                            <div style={{ display: 'grid' }}>
                                <span style={{ fontSize: 10 }}><strong>DMS:</strong> {settings?.dms?.level}</span>
                                <span style={{ fontSize: 10 }}><strong>ADAS:</strong> {settings?.advanced?.adas?.level}</span>
                                <span style={{ fontSize: 10 }}><strong>{messages['show_restrictions_video_resolution']}:</strong> {settings?.recordConfig?.config}</span>
                                <span style={{ fontSize: 10 }}><strong>{model2 ? messages['show_restrictions_model2'] : messages['show_restrictions_model']}:</strong> {model2 ? settings?.advanced?.aux?.model2 : settings?.advanced?.aux?.model}</span>
                                <span style={{ fontSize: 10 }}><strong>{messages['show_restrictions_pc_control']}:</strong> {settings?.advanced?.privacyControl?.level}</span>
                            </div>
                        </Alert>
                    }
                    <FormControl style={{ width: '100%', marginTop: 10 }}>
                        <OutlinedInput
                            id="custom-search"
                            placeholder={messages['search']}
                            type="text"
                            style={{ height: 35 }}
                            value={openSearch || ''}
                            fullWidth={true}
                            onChange={() => setOpenSearch(event.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <Icon style={{ marginRight: 5, opacity: 0.4, marginTop: -3 }}>search</Icon>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                    <div className="restrictions-table">
                        <Table
                            ref={tableRef}
                            columns={[
                                {
                                    key: "dmsLevel",
                                    title: "DMS",
                                    width: 50,
                                    show: true,
                                    render: (item) => {
                                        return <span>{item?.dmsLevel}</span>
                                    }
                                },
                                {
                                    key: "adasLevel",
                                    title: "ADAS",
                                    width: 50,
                                    show: true,
                                    render: (item) => {
                                        return <span>{item?.adasLevel}</span>
                                    }
                                },
                                {
                                    key: "recordProfile",
                                    title: messages['show_restrictions_video_resolution'],
                                    width: 50,
                                    show: true,
                                    render: (item) => {
                                        return <span>{item?.recordProfile}</span>
                                    }
                                },
                                {
                                    key: "auxModel",
                                    title: messages['show_restrictions_model'],
                                    width: 50,
                                    show: true,
                                    render: (item) => {
                                        return <span>{item?.auxModel}</span>
                                    }
                                },
                                {
                                    key: "privacyControl",
                                    title: messages['show_restrictions_pc_control'],
                                    show: true,
                                    render: (item) => {
                                        return <span>{item?.privacyControl}</span>
                                    }
                                }
                            ]}
                            data={restrictionsList || []}
                            height="63vh"
                            infiniteScroll
                            disableItemSelection
                            onChangePage={() => { }}
                            messages={messages}
                            noMoreItemsMessage={messages['no_more_items']}
                        />
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="restrictions-footer">
                    <Button
                        className="btn btn-dark-blue"
                        onClick={(e) => closeModal()}
                    >
                        {messages['show_restrictions_modal_close']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default ShowRawData;